import { render } from "./기억장애_치매클리닉.vue?vue&type=template&id=6926238c"
import script from "./기억장애_치매클리닉.vue?vue&type=script&lang=js"
export * from "./기억장애_치매클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__